var _path, _path2, _path3, _path4, _g, _path5, _path6, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDouble = function SvgDouble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4916_1123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4916_1123)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "url(#paint0_linear_4916_1123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "url(#paint1_linear_4916_1123)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C2 16.4142 2 13.6213 2.78563 11.3761C4.1928 7.35464 7.35464 4.1928 11.3761 2.78563C13.6213 2 16.4142 2 22 2C27.5858 2 30.3787 2 32.6239 2.78563C36.6454 4.1928 39.8072 7.35464 41.2144 11.3761C42 13.6213 42 16.4142 42 22C42 27.5858 42 30.3787 41.2144 32.6239C39.8072 36.6454 36.6454 39.8072 32.6239 41.2144C30.3787 42 27.5858 42 22 42C16.4142 42 13.6213 42 11.3761 41.2144C7.35464 39.8072 4.1928 36.6454 2.78563 32.6239C2 30.3787 2 27.5858 2 22Z",
    fill: "url(#paint2_linear_4916_1123)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4916_1123",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 41,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.15723 22.2393C2.15723 16.6535 2.15723 13.8606 2.94286 11.6154C4.35003 7.59389 7.51186 4.43206 11.5333 3.02489C13.7785 2.23926 16.5714 2.23926 22.1572 2.23926C27.743 2.23926 30.5359 2.23926 32.7811 3.02489C36.8026 4.43206 39.9644 7.59389 41.3716 11.6154C42.1572 13.8606 42.1572 16.6535 42.1572 22.2393C42.1572 27.8251 42.1572 30.618 41.3716 32.8632C39.9644 36.8846 36.8026 40.0465 32.7811 41.4536C30.5359 42.2393 27.743 42.2393 22.1572 42.2393C16.5714 42.2393 13.7785 42.2393 11.5333 41.4536C7.51186 40.0465 4.35003 36.8846 2.94286 32.8632C2.15723 30.618 2.15723 27.8251 2.15723 22.2393Z",
    fill: "#9E01F2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4916_1123)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.772908 20.1476L-6.26005 29.0738C-2.35299 32.1007 2.00999 34.1508 6.53075 35.2636L9.29909 24.2737C6.16006 23.4998 3.26262 22.0775 0.772908 20.1476Z",
    fill: "#484C52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3197 24.6771C13.8518 24.8497 11.4484 24.6222 9.17078 24.0528L6.3976 35.2175C10.9401 36.3571 15.7883 36.5817 20.6969 35.7148L18.7027 24.3855C17.9225 24.5221 17.1274 24.6206 16.3197 24.6771Z",
    fill: "#F05228"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6747 24.2776L20.6155 35.5036C25.0467 34.7092 29.3878 32.9633 33.3538 30.2053L27.1684 20.7518C24.6694 22.4931 21.7944 23.7204 18.6747 24.2776Z",
    fill: "#4CEB06"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4099 20.9983L33.6473 30.5082C37.4044 27.9046 40.7014 24.4638 43.2524 20.2491L33.8141 14.1611C32.1716 16.8692 29.9903 19.2049 27.4099 20.9983Z",
    fill: "#484C52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.857 14.0976L43.2948 20.0323C45.7007 16.1627 47.3569 11.7341 48.0273 6.92135L37.0196 5.36083C36.5824 8.52076 35.4822 11.4856 33.857 14.0976Z",
    fill: "#F05228"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.0986328,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.2785 0.629478C38.1515 13.0168 28.8378 23.7646 16.4756 24.6357C4.11342 25.5069 -6.61556 16.1713 -7.48851 3.78403C-8.36145 -8.60328 0.952224 -19.3511 13.3144 -20.2222C25.6766 -21.0934 36.4056 -11.7578 37.2785 0.629478ZM-10.8525 4.02625C-9.84867 18.2714 2.48982 29.0074 16.7061 28.0056C30.9223 27.0038 41.6332 14.6437 40.6293 0.398524C39.6255 -13.8466 27.287 -24.5828 13.0707 -23.5811C-1.14555 -22.5793 -11.8564 -10.2189 -10.8525 4.02625Z",
    fill: "#1A1919"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8931 19.9694C14.5415 20.1159 17.193 19.7352 19.6767 18.852C22.1605 17.9689 24.4215 16.6027 26.3141 14.8415C28.2068 13.0803 29.6891 10.9632 30.6658 8.62633C31.6424 6.28951 32.0916 3.78483 31.9846 1.27356L24.4809 1.56069C24.5457 3.07938 24.274 4.59409 23.6834 6.00728C23.0928 7.42047 22.1963 8.70083 21.0517 9.7659C19.9072 10.831 18.5398 11.6572 17.0378 12.1913C15.5357 12.7254 13.9322 12.9556 12.3306 12.867L11.8931 19.9694Z",
    fill: "url(#paint3_linear_4916_1123)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 16.5C15 18.433 13.433 20 11.5 20C9.567 20 8 18.433 8 16.5C8 14.567 9.567 13 11.5 13C13.433 13 15 14.567 15 16.5Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4916_1123",
    x1: 2,
    y1: 22,
    x2: 42,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E01F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0131B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4916_1123",
    x1: 2,
    y1: 22,
    x2: 42,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E01F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0131B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4916_1123",
    x1: 2,
    y1: 22,
    x2: 42,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9E01F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0131B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4916_1123",
    x1: 10.8889,
    y1: 20.5,
    x2: 26.3317,
    y2: 11.8063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4916_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4916_1123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDouble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/double.a4990790.svg";
export { ForwardRef as ReactComponent };